
  import Vue from 'vue';
  import {mapState, mapMutations} from 'vuex';
  import * as VuexMutation from '@/store/mutation-types';
  import * as util from '@/util';
  import {Track} from '@/models/track';
  import {Playlist, getPlaylistUrl} from '@/models/playlist';
  import Message from '@/models/message';
  import Card from '@/models/card';

  export default Vue.extend({
    name: 'Playlists',
    components: {
      CardList: () => import ('@/components/CardList.vue'),
      TrackList: () => import ('@/components/TrackList.vue'),
    },
    data() {
      return {
        selectedPlaylist: null as Playlist | null,
        renameDialog: false,
        deleteDialog: false,
        renamedPlaylistName: '',
        renamePlaylistErrorMessage: null as Message | null,
      }
    },
    computed: {
      ...mapState(['playlists', 'searchQuery']),
      playlistCards: function(): Card[] {
        return this.playlists.map((playlist: Playlist) => {
          return {
            id: playlist.name,
            title: playlist.name,
            subtitle: playlist.tracks.length + ' 曲',
            thumbnailUrl: playlist.tracks.length ? playlist.tracks[0].video.getThumbnailURL('hqdefault') : '',
            metadata: '',
          }
        })
      },
      selectedPlaylistThumbnail(): string {
        const track = this.selectedPlaylist && this.selectedPlaylist.tracks.length ? this.selectedPlaylist.tracks[0] : null;
        return track ? track.video.getThumbnailURL('hqdefault') : '';
      }
    },
    methods: {
      ...mapMutations({
        addPlaylist: VuexMutation.ADD_PLAYLIST,
        removePlaylist: VuexMutation.REMOVE_PLAYLIST,
        updatePlaylist: VuexMutation.UPDATE_PLAYLIST,
        renamePlaylist: VuexMutation.RENAME_PLAYLIST,
        addToQueue: VuexMutation.ADD_TO_QUEUE,
        setQueue: VuexMutation.SET_QUEUE,
        setPlayingTrack: VuexMutation.SET_PLAYING_TRACK,
        setPlayerRepeat: VuexMutation.SET_PLAYER_REPEAT,
        addMessage: VuexMutation.ADD_MESSAGE,
      }),
      onClick(playlistCard: Card) {
        this.selectedPlaylist = this.playlists.find(
          (playlist: Playlist) => playlist.name == playlistCard.id
        ) || null;
      },
      deleteTrack(targetTrack: Track) {
        if (!this.selectedPlaylist) {
          throw Error("no playlist selected");
        }
        this.selectedPlaylist.tracks = this.selectedPlaylist.tracks.filter(track => track.uuid !== targetTrack.uuid);
        this.updatePlaylist(this.selectedPlaylist);
      },
      updatePlaylistTracks(tracks: Track[]) {
        if (!this.selectedPlaylist) {
          throw Error("no playlist selected");
        }
        this.selectedPlaylist.tracks = tracks;
        this.updatePlaylist(this.selectedPlaylist)
      },
      renameSelectedPlaylist() {
        if (!this.selectedPlaylist) {
          throw Error("no playlist selected");
        }
        if (
          this.selectedPlaylist.name !== this.renamedPlaylistName
          && this.playlists.find((playlist: Playlist) => playlist.name === this.renamedPlaylistName)
        ) {
          this.renamePlaylistErrorMessage = new Message(
            'error',
            'プレイリストが既に存在します'
          );
          return;
        }
        this.renamePlaylist({targetPlaylist: this.selectedPlaylist, newName: this.renamedPlaylistName});
        this.renameDialog = false;
      },
      deleteSeledtedPlaylist() {
        if (!this.selectedPlaylist) {
          throw Error("no playlist selected");
        }
        this.removePlaylist(this.selectedPlaylist);
        this.addMessage(new Message('info', 'プレイリスト "' + this.selectedPlaylist.name + '" を削除しました'));
        this.selectedPlaylist = null;
        this.deleteDialog = false;
      },
      addTracksToQueue() {
        if (!this.selectedPlaylist) {
          throw Error("no playlist selected");
        }
        this.selectedPlaylist.tracks.map(track => this.addToQueue(track.clone()));
      },
      shuffleAndQueue() {
        if (!this.selectedPlaylist) {
          throw Error("no playlist selected");
        }
        const tracks = util.shuffle(this.selectedPlaylist.tracks);
        if (tracks.length > 0) {
          this.setPlayingTrack(tracks[0]);
          this.setQueue(tracks);
        }
      },
      queueAndRepeat() {
        if (!this.selectedPlaylist) {
          throw Error("no playlist selected");
        }
        const tracks = this.selectedPlaylist.tracks;
        if (tracks.length > 0) {
          this.setPlayingTrack(tracks[0]);
          this.setQueue(tracks);
          this.setPlayerRepeat('repeat');
        }
      },
      getSelectedPlaylistUrl() {
        if (!this.selectedPlaylist) {
          throw Error("no playlist selected");
        }
        return getPlaylistUrl(this.selectedPlaylist);
      },
      copySelectedPlaylistUrl() {
        const url = this.getSelectedPlaylistUrl();
        window.navigator.clipboard.writeText(url);
        this.addMessage(new Message('info', 'プレイリストのURLをコピーしました'));
      },
      getTwitterShareUrl() {
        const url = this.getSelectedPlaylistUrl();
        const message = `プレイリスト『${this.selectedPlaylist?.name}』\n#アキくんのおうた\n${url}`;
        return 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(message);
      },
    },
    watch: {
      renameDialog() {
        if(!this.renameDialog) this.renamePlaylistErrorMessage = null;
      }
    }
  });
